import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import ElementRenderer from "@/components/editor/ElementRenderer";

export default function Published() {
  const { slug } = useParams();
  const [site, setSite] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    api
      .get(`/published/${slug}`)
      .then(({ data }) => setSite(data))
      .catch((e) => setErr(e.response?.data?.detail || "Not found"));
  }, [slug]);

  if (err) return <div className="min-h-screen flex items-center justify-center text-gray-500">{String(err)}</div>;
  if (!site) return <div className="min-h-screen flex items-center justify-center text-gray-400">Loading…</div>;

  return (
    <div className="min-h-screen bg-gray-100" data-testid="published-view">
      {site.pages.map((page) => (
        <div
          key={page.id}
          className="relative w-full max-w-[1024px] mx-auto bg-white"
          style={{
            background: page.backgroundImage
              ? `url(${page.backgroundImage}) center/cover no-repeat`
              : page.background || "#FFFFFF",
            minHeight: 600,
          }}
        >
          <div className="relative" style={{ width: "100%", height: 600 }}>
            {page.elements.map((el) => (
              <ElementRenderer key={el.id} element={el} preview />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
